import styled from 'styled-components';

import { colours, device } from '../../styles/constants';
import { lg, xl } from '../../styles/mixins';

export const Container = styled.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginLeft: '-48%',
  marginTop: 10,
  position: 'absolute',
  left: '50%',
  top: 25,
  width: '96%',
  zIndex: 1,
  [`@media ${device.tabletP}`]: {
    marginLeft: '-47%',
    width: '94%',
  },
  [`@media ${device.tabletL}`]: {
    marginLeft: '-31%',
    width: '62%',
  },
  [`@media ${device.laptop}`]: {
    marginLeft: '-28%',
    width: '56%',
    marginTop: lg(10),
  },
  [`@media ${device.desktop}`]: {
    marginTop: xl(10),
  },
});

export const ProgressBlock = styled.div({
  position: 'relative',
});

interface ProgressItemProps {
  isActive: boolean;
  isComplete: boolean;
}

export const ProgressItem = styled.div<ProgressItemProps>(
  ({ isActive, isComplete }) => ({
    alignItems: 'center',
    backgroundColor: isActive
      ? `${colours.white}`
      : isComplete
      ? `${colours.green}`
      : `${colours.defaultGrey}`,
    borderRadius: '50%',
    color: !isComplete ? `${colours.black}` : `${colours.white}`,
    display: 'flex',
    fontSize: 11,
    height: 30,
    justifyContent: 'center',
    position: 'relative',
    width: 30,
    zIndex: 1,
    [`@media ${device.laptop}`]: {
      fontSize: lg(14),
      height: lg(35),
      width: lg(35),
    },
    [`@media ${device.desktop}`]: {
      fontSize: xl(14),
      height: xl(35),
      width: xl(35),
    },
  }),
);

interface ProgressBarProps {
  step: number;
  isComplete: boolean;
}

export const ProgressBar = styled.div<ProgressBarProps>(
  ({ isComplete, step }) => ({
    backgroundColor: isComplete ? `${colours.green}` : '#ccc',
    borderBottom: `1px solid ${isComplete ? `${colours.green}` : 'black'}`,
    display: step === 9 ? 'none' : 'block',
    height: lg(4),
    left: lg(2),
    marginTop: lg(-1.5),
    position: 'absolute',
    top: '50%',
    width: '10vw',
    zIndex: 0,
    [`@media ${device.tabletL}`]: {
      width: '7vw',
    },
    [`@media ${device.laptop}`]: {
      height: lg(4),
      left: lg(2),
      marginTop: lg(-1.5),
    },
    [`@media ${device.desktop}`]: {
      height: xl(4),
      left: xl(2),
      marginTop: xl(-1.5),
    },
  }),
);
